<template>
    <div class="lo router">
        <loPage>
            <loSection>
                <loArticle>
                    <mdCartCaption
                        :caption="$t('page.video.caption')"
                        :needBottomLine="false"
                    ></mdCartCaption>
                    <div class="md search major">
                        <div class="cp input text">
                            <input type="text" :placeholder="$t('page.search.func.search')" v-model="search">
                        </div>
                        <div class="func">
                            <a href="#" @click.prevent="tag('')" v-if="search"></a>
                        </div>
                    </div>
                    <div class="tag-showcase">
                        <cpLabel 
                            :text="$t('page.video.tag.all')"
                            :class="[search === '' ? 'is-major' : '']"
                            @click.native="tag('')" 
                        ></cpLabel>
                        <cpLabel v-for="label in labels" :key="label"
                            :text="$t(label)"
                            :class="[search === $t(label) ? 'is-major' : '']"
                            @click.native="tag($t(label))" 
                        ></cpLabel>
                    </div>
                    <div class="video-selector">
                        <a href="#"
                            class="img-block" 
                            v-for="item in searchResult" 
                            :key="item.tapeID" 
                            @click="video(item.tapeID)"
                        >
                            <div class="img">
                                <img :src="'https://img.youtube.com/vi/'+ item.tapeID +'/sddefault.jpg'" :alt="item.tapeName">
                            </div>
                            <div class="image-caption">{{ item.tapeName }}</div>
                        </a>
                    </div>
                </loArticle>
            </loSection>
        </loPage>
    </div>
</template>
<script>
    import loPage from '@/components/loPage'
    import mdCartCaption from '@/components/mdCartCaption'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import cpLabel from '@/components/cpLabel'

    import { mapMutations } from 'vuex'

    export default {
        components: {
            loPage,
            loSection,
            loArticle,
            mdCartCaption,
            cpLabel
        },
        data: function(){

            return {
                search: '',
                tape: [],
                labels: [],
            }
        },
        computed: {
            searchResult: function(){
                let $tape = this.tape,
                    _keyword = this.search;

                if(_keyword){
                    let target = $tape.filter(item => item.tapeName.includes(_keyword) || item.label.includes(_keyword))

                    return target;
                }else {
                    return $tape;
                }
            }
        },
        methods: {
            ...mapMutations([
                'catchError',
                'pushPopUp',
            ]),
            video: function(filmID){
                let target = this.tape.filter(item => item.tapeID === filmID);

                this.pushPopUp({
                    type: 'videoBlock',
                    content: {
                        film: filmID,
                        caption: target[0].tapeName
                    }
                })
            },
            tag: function(key){
                this.$set(this, 'search', key)
            },
            getList: function(){

                this.$http.get(process.env.BASE_URL +'video.json').then(res=>{
                    let $data = res.data,
                        $labels = []

                    $data.forEach(data => {
                        let $label = data.label;

                        $label.forEach(label => {

                            if( !$labels.includes(label) ) {
                                $labels.push(label);
                            }
                        });
                    });
                    
                    this.$set(this, 'tape', $data);
                    this.$set(this, 'labels', $labels);

                }).catch(error => {

                    this.catchError({
                        error: error,
                        callback: this.getList,
                    });
                })
            },
        },
        created: function(){
            this.getList();
        },
    }
</script>
<style scoped lang="scss">
    .lo.router {
        max-width: 1200px;
        margin: 0 auto;
    }

    .md.search.major {
        $size: 48px;
        position: relative;
        padding: 0;
        margin-top: 0 !important;

        .cp.input {
            display: block;
            width: auto;

            &:before {
                @extend %font-pseudo;
                content: '\e8b6';
                position: absolute;
                left: 0;
                top: 0;
                width: $size;
                height: $size;
                line-height: $size;
                font-size: $font-size-xl;
                text-align: center;
                color: $major-color;
            }
            
            input {
                padding-left: $size;
                width: 100%;
                height: $size;
                line-height: $size;
            }
        }

        .func {

            a {
                position: absolute;
                width: $size;
                height: $size;
                right: 0;
                top: 0;
                transition: $transition;

                &:hover {
                    opacity: $opacity-m;
                }

                &:before {
                    @extend %font-pseudo;
                    content: '\e5cd';
                    width: $size;
                    height: $size;
                    line-height: $size;
                    font-size: $font-size-l;
                    text-align: center;
                    color: $deep;
                }
            }
        }
    }

    .tag-showcase {
        margin-top: $interval-l;

        .label::v-deep {
            font-size: $font-size-l;
            cursor: pointer;

            &:hover {
                
            }
        }
    }

    .video-selector{
        margin-top: $interval-l;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: $interval-s;

        @include media('pc') {
            grid-template-columns: repeat(3, 1fr);
        }

        @include media('mobile') {
            grid-template-columns: repeat(2, 1fr);
        }

        @include media('phone') {
           grid-template-columns: repeat(1, 1fr);
        }

        a.img-block {
            display: block;
            width: 100%;

            .img {
                width: 100%;
                img {
                    width: 100%;
                    object-fit: cover;
                }
            }
            .image-caption {
                text-align: center;
                line-height: $line-height-s;
                color: #000;
                width: 100%;
                padding: $interval-m;
                font-size: $font-size-l;
                box-sizing: border-box;
                // overflow: hidden;
                // white-space: nowrap;
                // text-overflow: ellipsis;
            }
        }
    }
</style>
